import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Section from "pages/components/Section";
import { formatPrice, getDateFormat } from "pages/Utils/Formats";
import { useTranslation } from "react-i18next";

import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import { PaymentPlanConfig } from "Domain/PaymentPlan/Helper/PaymentsCalculator";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    padding: 0,
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    padding: "5px 0",
    fontSize: 14,
  },
}));

type DisplayPayInsProps = {
  paymentPlanConfig: PaymentPlanConfig;
};

export default function DisplayPayIns({
  paymentPlanConfig,
}: DisplayPayInsProps) {
  const { t } = useTranslation();
  const collections = paymentPlanConfig.getPayInsCollections();

  return (
    <Section title={"payments_in"}>
      <TableContainer sx={{ marginTop: -3, marginBottom: -2 }}>
        <Table
          sx={{
            tableLayout: "fixed",
            "& tbody tr:last-child td": {
              borderBottom: "none",
            },
          }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow style={{ fontWeight: "bold" }}>
              <StyledTableCell width={30} align="left">
                #
              </StyledTableCell>
              <StyledTableCell align="left">
                {t("FORM.FIELD.date")}
              </StyledTableCell>
              <StyledTableCell align="right">
                {t("FORM.FIELD.amount")}
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {collections.map((collection: any, i: number) => (
              <TableRow
                key={i}
                sx={{
                  overflow: "clip",
                }}
              >
                <StyledTableCell
                  sx={{ fontWeight: "bold" }}
                  width={30}
                  align="left"
                >
                  {i + 1}
                </StyledTableCell>
                <StyledTableCell align="left">
                  {collection.date.format(getDateFormat())}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {formatPrice(collection.amount)}
                </StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Section>
  );
}
